import axios from "axios";
import { Base_URL } from "../url";

export const createPartner = async (partnerData, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/PartnerMaster/CreatePartner?UserName=${userName}`,
      partnerData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error creating partner!";
  }
};

export const updatePartner = async (partnerId, partnerData) => {
  try {
    const response = await axios.put(
      `${Base_URL}/PartnerMaster/UpdatePartner/${partnerId}`,
      partnerData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error updating partner!";
  }
};

export const getPartnersByOrg = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/PartnerMaster/GetPartnersByOrg/${orgId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching partners by organization!";
  }
};

export const getPartnerById = async (partnerId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/PartnerMaster/GetPartnerById/${partnerId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching partner details!";
  }
};

export const getAllPartners = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/PartnerMaster/GetAllPartners`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching all partners!";
  }
};

export const getPartnersByProject = async (projectId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/PartnerMaster/GetPartnersByProject/${projectId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching partners by project!";
  }
};
